"use client";

import React from "react";
import { Images, Icons } from "@/app/assets/shared";
import Image from "next/image";

export default function Locations() {
  return (
    <section className="bg-[#FFF] py-[60px] lg:py-[100px]">
      <div className="max-w-[2500px] m-auto w-[calc(100%_-_10%)]">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-[30px]">
          {/* USA Card */}
          <div className="relative bg-white border border-[#ECF0F6] rounded-[0px] p-[30px] lg:p-[40px] overflow-hidden min-h-[260px]">
            <div className="relative z-[1] max-w-[520px]">
              <div className="flex items-center gap-3 mb-4">
                <Image
                  src={Images?.contactUs.usa as any}
                  alt="USA flag"
                  width={28}
                  height={28}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                  className="[@media(min-width:1800px)]:block h-[28px]"
                />
                <h3 className="text-[#00040b] text-[clamp(20px,3vw,24px)] clash-font font-medium">
                  NYC, US
                </h3>
              </div>
              <p className="text-[#000] leading-[1.6] max-w-[24ch] font-[600] mb-4 text-[clamp(14px,2vw,16px)]">
                590 Madison Avenue, 21st Floor, New York NY 10022
              </p>
              <a
                href="tel:+13109335465"
                className="block text-[clamp(14px,2vw,16px)] text-[#001021] underline underline-offset-4 mb-4"
              >
                +1-310-933-5465
              </a>
              <a
                href="mailto:sales@konstantinfo.com"
                className="block text-[clamp(14px,2vw,16px)] text-[#636364] underline underline-offset-4"
              >
                sales@konstantinfo.com
              </a>
            </div>
            <Image
              src={Images?.contactUs.status as any}
              alt="Statue of Liberty"
              width={400}
              height={400}
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="absolute right-[10px] bottom-0 h-full w-auto opacity-70 pointer-events-none select-none hidden [@media(min-width:1800px)]:block"
            />
          </div>

          {/* India Card */}
          <div className="relative bg-white border border-[#ECF0F6] rounded-[0px] p-[30px] lg:p-[40px] overflow-hidden min-h-[260px]">
            <div className="relative z-[1] max-w-[620px]">
              <div className="flex items-center gap-3 mb-4">
                <Image
                  src={Images?.contactUs.india as any}
                  alt="India flag"
                  width={28}
                  height={28}
                  className="w-[28px] h-[28px]"
                />
                <h3 className="text-[#00040b] text-[clamp(20px,3vw,24px)] clash-font font-medium">
                  INDIA
                </h3>
              </div>
              <p className="text-[#000] max-w-[30ch] font-[600] leading-[1.6] mb-4 text-[clamp(14px,2vw,16px)]">
                A-23, Swej Farm, Reliance Fresh Lane, New Sanganer Road, Jaipur
                302019
              </p>

              <a
                href="tel:+911412291398"
                className="block text-[clamp(14px,2vw,16px)] text-[#001021] underline underline-offset-4 mb-2"
              >
                +91-141-2291398
              </a>

              <a
                href="tel:+914028078"
                className="block text-[clamp(14px,2vw,16px)] text-[#001021] underline underline-offset-4 mb-4"
              >
                4028078
              </a>

              <a
                href="mailto:mail@konstantinfo.com"
                className="block text-[clamp(14px,2vw,16px)] text-[#636364] underline underline-offset-4"
              >
                mail@konstantinfo.com
              </a>
            </div>
            <Image
              src={Images?.contactUs.gate as any}
              alt="India Gate"
              width={400}
              height={400}
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="absolute right-[10px] bottom-0 h-full w-auto opacity-70 pointer-events-none select-none hidden [@media(min-width:1800px)]:block"
            />
          </div>

          {/* Middle East Card  */}
          <div className="relative bg-white border border-[#ECF0F6] rounded-[0px] p-[30px] lg:p-[40px] overflow-hidden min-h-[260px]">
            <div className="relative z-[1] max-w-[620px]">
              <div className="flex items-center gap-3 mb-4">
                <Image
                  src={Icons?.contactUs.dubaiFlag as any}
                  alt="India flag"
                  width={28}
                  height={28}
                  sizes="(max-width: 1024px) 100vw, 50vw"
                  className="w-[28px] h-[28px]"
                />
                <h3 className="text-[#00040b] text-[clamp(20px,3vw,24px)] clash-font font-medium">
                  Dubai, UAE
                </h3>
              </div>
              <p className="text-[#000] max-w-[30ch] font-[600] leading-[1.6] mb-4 text-[clamp(14px,2vw,16px)]">
                The Bridge Building, Levels 2, 3, 4 & 5, Dubai Sports City,
                Dubai, ARE
              </p>
              <a
                href="tel:+911412291398"
                className="block text-[clamp(14px,2vw,16px)] text-[#001021] underline underline-offset-4 mb-4"
              >
                +1-310-933-5465
              </a>
              <a
                href="mailto:mail@konstantinfo.com"
                className="block text-[clamp(14px,2vw,16px)] text-[#636364] underline underline-offset-4"
              >
                sales@konstantinfo.com
              </a>
            </div>
            <Image
              src={Icons?.contactUs.dubai as any}
              alt="India Gate"
              width={400}
              height={400}
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="absolute right-[10px] bottom-0 h-full w-auto opacity-70 pointer-events-none select-none hidden [@media(min-width:1800px)]:block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
